































































import { Vue, Component, Ref, Prop } from 'nuxt-property-decorator';
import TooltipButton from '../ui/TooltipButton';
import CloseBtn from './side-panel/CloseBtn.vue';
import AudioPlayerEmbed from './embeds/AudioPlayerEmbed.vue';
import glossaryStore from '@/store/glossary.store';
import { ICoordinates } from '@/util/getCoordinates';
import { Glossary } from '@/types/pageContract';
import { ReadingMode } from "./read-aloud/library/models";
import ReadAloudStore from "./read-aloud/library/read-aloud.store";
import NotesStore from "../../store/notes.store";


@Component({
  components: {
    TooltipButton,
    AudioPlayerEmbed,
    CloseBtn
  }
})
export default class GlossaryPreview extends Vue {
  isTooCloseToBottom: boolean = true;

  get currentGlossary(): Glossary | null {
    return glossaryStore.currentGlossary;
  }

  get glossaryAudio(): string {
    const glossaryAudio = this.currentGlossary.media;
    const audioUrl1 = glossaryAudio.substring(0, glossaryAudio.indexOf('.mp3'));
    const audioUrl2 = audioUrl1.split('api')[1];
    return audioUrl2 + '.mp3';
  }

  get coordinates(): ICoordinates {
    return glossaryStore.coordinates;
  }

  get positioningStyles() {
    if (this.$vuetify.breakpoint.mdAndUp) {
      return {
        top: `${this.coordinates.y}px`,
        left: `${this.coordinates.x}px`,
        transform: this.isTooCloseToBottom
          ? 'translateX(-50%) translateY(-100%)'
          : 'translateX(-50%)',
        margin: this.isTooCloseToBottom ? '0 0 2rem 0' : '2.5rem 0 0 0'
      };
    }

    return {
      top: `${this.coordinates.y}px`,
      left: `1.6rem`,
      right: '1.6rem',
      margin: this.isTooCloseToBottom ? '0 0 2rem 0' : '2.5rem 0 0 0'
    };
  }

  @Ref()
  glossaryPreviewContent: HTMLElement;

  @Prop({ type: Boolean, default: false })
  sharePage!: boolean;

  @Prop({ type: Number, default: 9999 })
  cId!: number;

  @Prop({ type: String, default: 'c9999' })
  cid!: string;

  mounted() {
    this.determineGlossaryPosition();
  }

  initReadAloud(): void {
    const internalReadingMode = this.sharePage
      ? ReadingMode.Document
      : ReadingMode.Section;

    if (internalReadingMode === ReadingMode.Section) {
      // We set the range when the parent is expanded
      ReadAloudStore.startSectionId = 9999;
      this.openParentIfClosed(this.$parent);
    }

    ReadAloudStore.playerShowing = true;

    this.closeContextMenu();
  }

  private openParentIfClosed(parent: Vue): void {
    if (!parent) {
      return;
    }
    const id = this.cid;

    if (
      id &&
      id.startsWith('c') &&
      Number(id.substring(1, id.length) !== Number.NaN)
    ) {
      parent.$nextTick(this.notifyReadAloud);
    } else {
      this.openParentIfClosed(parent.$parent);
    }
  }

  private notifyReadAloud(): void {
    const cId = `readAloudGlossary`;
    const section = document.getElementById(cId);
    const range = document.createRange().cloneRange();
    range.setStart(section, 0);
    range.setEnd(section, 1);

    ReadAloudStore.notifyReadAloud(range);

    document.getSelection().removeAllRanges();
  }

  closeContextMenu(): void {
    NotesStore.closeContextMenu();
  }

  determineGlossaryPosition(): void {
    if (!this.glossaryPreviewContent) {
      return;
    }

    this.isTooCloseToBottom =
      window.innerHeight - this.coordinates.bottom <
      this.glossaryPreviewContent.clientHeight - 64;
  }

  closeGlossary(): void {
    glossaryStore.closeGlossary();
  }
}
